import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useLang } from "../lib/i18n";
import { fullName } from "../lib/helpers";

export default function CustomerPicker({ value, onChange, testid = "customer-picker" }) {
  const { t } = useLang();
  const [list, setList] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => {
    api.get("/customers").then((r) => setList(r.data)).catch(() => {});
  }, []);
  const shown = list.filter((c) =>
    `${fullName(c)} ${c.phone} ${c.email} ${c.property_address}`.toLowerCase().includes(q.toLowerCase())
  );
  return (
    <div className="space-y-2">
      <input className="inp" placeholder={t("Search customer…", "Buscar cliente…")} value={q} onChange={(e) => setQ(e.target.value)} data-testid={`${testid}-search`} />
      <select className="inp" value={value || ""} onChange={(e) => onChange(e.target.value, list.find((c) => c.id === e.target.value))} data-testid={testid}>
        <option value="">{t("Select a customer", "Seleccione un cliente")}</option>
        {shown.map((c) => (
          <option key={c.id} value={c.id}>
            {fullName(c)} {c.phone ? `· ${c.phone}` : ""}
          </option>
        ))}
      </select>
    </div>
  );
}
